module.exports = __webpack_public_path__ + "img/sand_clock.b27df770.svg";